import { Parser } from 'm3u8-parser'
import axios from 'axios'

export default {
  methods: {
    parseManifest(manifest) {
      return new Promise((resolve, reject) => {
        if (!manifest) {
          reject(new Error('Manifest is not defined'))
        }
        const parser = new Parser()
        parser.push(manifest)
        parser.end()
        resolve(parser.manifest)
      })
    },
    parseFromUrl(url) {
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then(res => {
            this.parseManifest(res.data)
              .then(manifest => {
                resolve(manifest)
              })
              .catch(err => resolve(err))
          })
          .catch(err => {
            reject(err)
          })
      })
    },
  },
}
